import { CircularProgress } from '@mui/material';
import { ChatWithTabs } from '@features/socket-chats-reworked/components/chat-with-tabs';
import { Channels } from '@features/tickets/models/detail-sdui/types';
import * as Styled from './styled';

export const ChatsBlock = ({
  channels,
  pending,
}: {
  channels: Channels;
  pending: boolean;
}) => {
  const isMainChatExists = channels?.resident?.id;

  if (!isMainChatExists) return null;

  if (pending) {
    return (
      <Styled.ChatsBlockWrapper>
        <CircularProgress />
      </Styled.ChatsBlockWrapper>
    );
  }

  return (
    <ChatWithTabs
      mainChatId={channels.resident.id}
      technicalSupportChatId={channels.support?.id}
      standalone
      hideLeaveButton
    />
  );
};
